import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/campaigns/setup/planning")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex grow flex-col justify-center">
      <Outlet />
    </div>
  );
}
